export default "__VITE_ASSET__6Tw9mkGU__"